<header class="organizer-qr-code-error__header container">
  <app-logo
    class="organizer-qr-code-error__header__logo"
    height="28"
    [name]="logoType.OrganizerDark"
    [alt]="'a11y.fed_landing.logo' | translate"
  ></app-logo>
</header>
<main class="organizer-qr-code-error__content container">
  <app-section
    [title]="'organizer_qr_code_validation.error' | translate"
    class="organizer-qr-code-error__content__section"
  >
    <div class="organizer-qr-code-error__container">
      <img
        class="organizer-qr-code-error__container__image"
        src="./assets/errors/unknown.svg"
        alt="Code not found"
      />
    </div>
  </app-section>
</main>
